import {useRef, useEffect} from 'react'
import useAudioStore from '../stores/useAudioStore.js'

// Audio Import
import walkAudioSource from '../../public/sound/footsteps.mp3'
import laughter from '../../public/sound/shining.mp3'
import shepardAudioSource from '../../public/sound/shepard_tone_seamless.mp3'
import terrorAudioSource from '../../public/sound/terror.mp3'
import useGame from '../stores/useGame.js'



export default function AudioController() {

    // Zustand
    const {playShepardAudio} = useAudioStore()
    const {playTerrorAudio} = useAudioStore()
    const {playWalkAudio} = useAudioStore()

    // Create Audio Elements with useRev to prevent multiple object instances
    const walkAudioRef = useRef(new Audio(walkAudioSource));
    const shepardAudioRef = useRef(new Audio(shepardAudioSource));
    const terrorAudioRef = useRef(new Audio(terrorAudioSource));

    // Clean up the audio elements when the component unmounts
    useEffect(()=>{
        return ()=>{
            shepardAudioRef.current.pause()
            terrorAudioRef.current.pause()
        }
    }, [])

    // Manage Audio Elements

    // FadeIn Function
    function fadeIn(sound) {
      let timer
      console.log('is it fading in?')
      if(sound.volume < 0.9985) {
        sound.volume += 0.0015
        timer = setTimeout(()=>{fadeIn(sound)}, 5)
      }
    }

    // Walk Audio
    useEffect(() => {
        // Create the audio element if it doesn't exist
        if (!walkAudioRef.current) {
          walkAudioRef.current = new Audio(walkAudioSource);
          walkAudioRef.current.loop = true;
        }
    
        // Play or pause the audio based on the playWalkAudio state
        if (playWalkAudio) {
          if (walkAudioRef.current.paused) {
            walkAudioRef.current.play();
          }
        } else {
          // if (!walkAudioRef.current.paused) {
            walkAudioRef.current.pause();
          // }
        }
    
        return () => {
          // Clean up the audio element when the component unmounts
          if (walkAudioRef.current) {
            walkAudioRef.current.pause();
            walkAudioRef.current = null;
          }
        };
      }, [playWalkAudio]);

      // Shepard Tone Audio
      useEffect(() => {
        // Create the audio element if it doesn't exist
        if (!shepardAudioRef.current) {
          shepardAudioRef.current = new Audio(shepardAudioSource);
          shepardAudioRef.current.loop = true;
        }
    
        // Play or pause the audio based on the shepardAudio state
        if (playShepardAudio) {
          if (shepardAudioRef.current.paused) {
            shepardAudioRef.current.volume = 0
            fadeIn(shepardAudioRef.current)
            shepardAudioRef.current.play();
          }
        } else {
          if (!shepardAudioRef.current.paused) {
            shepardAudioRef.current.pause();
          }
        }
    
        return () => {
          // Clean up the audio element when the component unmounts
          if (shepardAudioRef.current) {
            shepardAudioRef.current.pause();
            shepardAudioRef.current = null;
          }
        };
      }, [playShepardAudio]);



//     // Terror Audio
      useEffect(() => {
        // Create the audio element if it doesn't exist
        if (!terrorAudioRef.current) {
          terrorAudioRef.current = new Audio(terrorAudioSource);
          terrorAudioRef.current.loop = true;
        }
    
        // Play or pause the audio based on the shepardAudio state
        if (playTerrorAudio) {
          if (terrorAudioRef.current.paused) {
            // terrorAudioRef.current.volume = 0
            terrorAudioRef.current.play();
          }
        } else {
          if (!terrorAudioRef.current.paused) {
            terrorAudioRef.current.pause();
          }
        }
    
        return () => {
          // Clean up the audio element when the component unmounts
          if (terrorAudioRef.current) {
            terrorAudioRef.current.pause();
            terrorAudioRef.current = null;
          }
        };
      }, [playTerrorAudio]);

    return null

}